import { apiDelete, apiGet, apiPatch, apiPost } from "../../client";
import { ApiConfig } from "../../config";

const DOCTOR_ROOT = `${ApiConfig.CLINIC_BASE}/doctor`;

/**
 * Fetch a paginated list of doctors.
 *
 * GET /clinic/api/doctors/?page=:page&page_size=:pageSize
 */
export async function fetchDoctorList({ page = 1, pageSize = 10, date = null, startTime = null, endTime = null, clinicBranchId = null, query = null } = {}) {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("page_size", pageSize);
  if (date) params.append("date", date);
  if (startTime) params.append("start_time", startTime);
  if (endTime) params.append("end_time", endTime);
  if (clinicBranchId) params.append("clinic_branch_id", clinicBranchId);
  if (query) params.append("query", query);
  return apiGet(`${ApiConfig.CLINIC_BASE}/doctors/?${params.toString()}`);
}

/**
 * Fetch the current doctor's default clinical note preference.
 *
 * GET /clinic/api/doctor-clinical-note-preference/
 */
export async function fetchDoctorClinicalNotePreference() {
  return apiGet(`${ApiConfig.CLINIC_BASE}/doctor-clinical-note-preference/`);
}

/**
 * Update the current doctor's default clinical note preference.
 *
 * PATCH /clinic/api/doctor-clinical-note-preference/
 */
export async function updateDoctorClinicalNotePreference(payload) {
  return apiPatch(`${ApiConfig.CLINIC_BASE}/doctor-clinical-note-preference/`, payload);
}

/**
 * Reset the current doctor's default clinical note preference.
 *
 * DELETE /clinic/api/doctor-clinical-note-preference/
 */
export async function resetDoctorClinicalNotePreference() {
  return apiDelete(`${ApiConfig.CLINIC_BASE}/doctor-clinical-note-preference/`);
}

/**
 * Create a follow-up appointment for a treatment.
 *
 * POST /clinic/api/treatments/:treatment_id/appointments/
 */
export async function createTreatmentAppointment(treatmentId, payload) {
  const numericId = Number.parseInt(treatmentId, 10);
  if (!Number.isFinite(numericId)) {
    throw new Error("ID การรักษาไม่ถูกต้อง");
  }

  const path = `${ApiConfig.CLINIC_BASE}/treatments/${numericId}/appointments/`;
  return apiPost(path, payload);
}

/**
 * Delete a follow-up appointment from a treatment.
 *
 * DELETE /clinic/api/treatments/:treatment_id/appointments/:treatment_appointment_id/
 */
export async function deleteTreatmentAppointment(treatmentId, appointmentId) {
  const numericTreatmentId = Number.parseInt(treatmentId, 10);
  if (!Number.isFinite(numericTreatmentId)) {
    throw new Error("ID การรักษาไม่ถูกต้อง");
  }

  const numericAppointmentId = Number.parseInt(appointmentId, 10);
  if (!Number.isFinite(numericAppointmentId)) {
    throw new Error("ID นัดหมายไม่ถูกต้อง");
  }

  const path = `${ApiConfig.CLINIC_BASE}/treatments/${numericTreatmentId}/appointments/${numericAppointmentId}/`;
  return apiDelete(path);
}
